export const orderCustomerMixin = {
  computed: {
    customer() {
      return !!this.order && !!this.order.customer ? this.order.customer : null
    },
  },
}
